export const isValidEmail = (email) => {
  if (/\S+@\S+\.\S+/.test(email)) {
    return true;
  }
  return false;
};

export const isValidUser = (user) => {
  if (user.firstName.length > 0 && user.lastName.length > 0 && isValidEmail(user.email)) {
    return true;
  }
  return false;
};

export const isValidValue = (value) => {
  if (value === "" || value === null || value === undefined) {
    return false;
  }
  return true;
};



// WEBPACK FOOTER //
// ./src/js/utils/validators.js